import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { RadioClickData } from '@/models/radio.click.data';

import { http } from './http';

export const RadioClicksAPI = {
  getAll: async (): Promise<AxiosResponse<RadioClickData[]>> => {
    return http.get(`api/${ApiVersion.V1}/radio-clicks`);
  },

  getById: async (id: string): Promise<AxiosResponse<RadioClickData>> => {
    return http.get(`api/${ApiVersion.V1}/radio-clicks/${id}`);
  },

  create: async (
    id: string,
    data: RadioClickData,
  ): Promise<AxiosResponse<RadioClickData>> => {
    return http.post(`api/${ApiVersion.V1}/radio-clicks/${id}`, data);
  },

  update: async (
    id: string,
    data: RadioClickData,
  ): Promise<AxiosResponse<RadioClickData>> => {
    return http.put(`api/${ApiVersion.V1}/radio-clicks/${id}`, data);
  },

  delete: async (id: string): Promise<AxiosResponse<void>> => {
    return http.delete(`api/${ApiVersion.V1}/radio-clicks/${id}`);
  },
};
